import axios from "axios";
import { externalAppType } from "../consts/externalAppType";

var extAppsUrl = window.config.extAppsApiUrl;
var lightUrl = window.config.lightApiUrl;

const ensureTrailingSlash = (url) => url.endsWith("/") ? url : `${url}/`;
const removeTrailingSlash = (url) => url.endsWith("/") ? url.slice(0, -1) : url;

const selectExternalBaseUrl = (sourceAppType) => {
  return sourceAppType == null
    ? ensureTrailingSlash(lightUrl)
    : `${removeTrailingSlash(extAppsUrl)}/${sourceAppType}/`;
}

export const validateCustomer = (model, sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.post(baseUrl + 'customer/validate', model)
}

export const registerDevice = (model, sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.post(baseUrl + 'purchase/confirm', model)
}

export const registerCustomer = (model, sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.post(baseUrl + 'customer/register', model)
}

export const getConsents = (sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.get(baseUrl + 'customer/consents')
}

export const getTradeInConsents = (sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.get(baseUrl + 'trade-in/consents')
}

export const tradeInDevice = (model, sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.post(baseUrl + 'trade-in/device', model);
}

export const validateTradeInRegistration = (transactionId, sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.get(baseUrl + 'trade-in/validate-registration/' + transactionId)
}

export const registerTradedDevice = (model, sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.post(baseUrl + 'trade-in/register-device', model)
}

export const getRegulationUrl = (offerId) => {
  return `/files/${offerId}`;
}

export const checkIsOfferAvaliable = (offerId, channel) => {
  return axios.post(lightUrl + `offer/verify`, { offerId: offerId, channel: channel });
}

export const getOfferIdByExternalId = (externalId, sourceAppType) => {
  const baseUrl = selectExternalBaseUrl(sourceAppType);
  return axios.get(baseUrl + `offer/extId/${externalId}`)
}

export const confirmPurchaseWithoutDevice = (model) => {
  return axios.post(lightUrl + `purchase/no-device/confirm`, model)
}

const selectBaseUrlByMapConfigKey = (mapSiteConfigKey) => {
  switch(mapSiteConfigKey) {
    case 'default':
    case 'lagardere':
      return lightUrl;

    case 'zabka':
      return selectExternalBaseUrl(externalAppType.zabka);

    default: throw Error('Map config key not supported');
  }
}

export const getPointOfSaleOffers = (mapSiteConfigKey) => {
  const baseUrl = selectBaseUrlByMapConfigKey(mapSiteConfigKey);
  return axios.post(baseUrl + `pointsOfSale`, { mapSiteConfigKey });
}

export const filterPointsOfSale = (mapSiteConfigKey, offerKey, NE_X_st, NE_Y_st, SW_X_st, SW_Y_st) => {
  const baseUrl = selectBaseUrlByMapConfigKey(mapSiteConfigKey);
  return axios.post(baseUrl + `pointsOfSale/locations`, { mapSiteConfigKey, offerKey, NE_X_st, NE_Y_st, SW_X_st, SW_Y_st });
}
